import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-9" }
const _hoisted_3 = { class: "field col-12 lg:col-3 text-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.t("company.company")), 1),
      _createVNode(_component_MultiSelect, {
        modelValue: _ctx.companiesIds,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companiesIds) = $event)),
        options: _ctx.companies,
        optionLabel: "name",
        optionValue: "id",
        placeholder: "-",
        filter: true
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Button, {
        label: _ctx.t('buttons.save'),
        icon: "pi pi-save",
        type: "button",
        class: "p-button-primary p-uppercase",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportEmployees()))
      }, null, 8, ["label"])
    ])
  ]))
}